import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {
  InfoModalService,
  InfoModalData,
} from '../../services/info-modal.service';
import { AnalyticsService } from '../../services/analytics.service';
import { Subscription } from 'rxjs';
import { DialogDefaultsDirective } from '../../directives/dialog-defaults.directive';

@Component({
  selector: 'app-info-modal',
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule, DialogDefaultsDirective],
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent implements OnDestroy {
  showDialog: boolean = false;
  modalData: InfoModalData | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private infoModalService: InfoModalService,
    private analyticsService: AnalyticsService,
  ) {
    const modalVisibleSub = this.infoModalService.isModalVisible$.subscribe(
      (isVisible) => {
        this.showDialog = isVisible;
      },
    );
    this.subscriptions.add(modalVisibleSub);

    const modalDataSub = this.infoModalService.modalData$.subscribe(
      (modalData) => {
        this.modalData = modalData;
        if (modalData?.analyticsOnShow) {
          this.analyticsService.trackVirtualEvent({
            ...modalData.analyticsOnShow,
            tipoEvento: 'Visualización',
          });
        }
      },
    );
    this.subscriptions.add(modalDataSub);
  }

  closeModal = () => {
    this.showDialog = false;
  };

  confirm = () => {
    if (this.modalData?.analyticsOnConfirm) {
      this.analyticsService.trackVirtualEvent({
        ...this.modalData.analyticsOnConfirm,
        tipoEvento: 'Interacción',
      });
    }
    if (this.modalData?.onConfirm) {
      this.modalData.onConfirm();
    }
    this.closeModal();
  };

  cancel = () => {
    if (this.modalData?.onCancel) {
      this.modalData.onCancel();
    }
    this.closeModal();
  };

  handleHide = () => {
    const onCloseCallback = this.modalData?.onClose;
    this.infoModalService.hide();
    if (onCloseCallback) {
      onCloseCallback();
    }
  };

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
